module.exports = __webpack_public_path__ + "static/media/main.1fc83c33.png";